module.exports = __webpack_public_path__ + "img/carte-france.9b7dc55c.svg";